import { Link as RouterLink, useNavigate } from 'react-router';
import { Box, Link, Typography } from '@/shared/ui';

import Button from '@/shared/ui/primitives/Button';

const rootSx = { display: 'flex', backgroundColor: 'gx.highlight', p: 3, alignItems: 'center' };
const textColSx = { display: 'flex', flexDirection: 'column', width: '66%' };
const captionSx = { fontSize: 20 };
const externalLinkSx = {
  color: 'gx.text',
  textDecorationColor: 'rgb(248 248 248 / 40%)',
  '--Link-underlineColor': 'rgb(248 248 248 / 40%)'
};
const ctaColSx = { display: 'flex', justifyContent: 'center', width: '34%' };
const ctaInnerSx = { alignItems: 'center', display: 'flex', flexDirection: 'column' };
const ctaButtonSx = { backgroundColor: 'text.primary', width: 208 };
const ctaLabelSx = { fontWeight: 'bold', color: 'primary.main' };
const loginLineSx = { mt: 0.5 };
const loginLinkSx = {
  color: 'gx.text',
  textDecorationColor: 'rgb(248 248 248 / 40%)',
  '--Link-underlineColor': 'rgb(248 248 248 / 40%)',
  fontWeight: 700
};

const UnregisteredBanner = () => {
  const navigate = useNavigate();
  return (
    <Box sx={rootSx}>
      <Box sx={textColSx}>
        <Typography variant='h2'>See the data in GX Go</Typography>
        <Typography
          sx={captionSx}
          variant='caption'
        >
          Sign up for GX Go to explore thousands of oil and energy transition spot prices and
          forward curves - or find out more on the General Index{' '}
          <Link
            href='https://www.general-index.com'
            rel='noopener noreferrer'
            sx={externalLinkSx}
            target='_blank'
          >
            website
          </Link>
          .
        </Typography>
      </Box>
      <Box sx={ctaColSx}>
        <Box sx={ctaInnerSx}>
          <Button
            sx={ctaButtonSx}
            variant='contained'
            onClick={() => {
              navigate('/onboarding');
            }}
          >
            <Typography
              sx={ctaLabelSx}
              variant='body1'
            >
              TRY FOR FREE
            </Typography>
          </Button>
          <Typography
            sx={loginLineSx}
            variant='body2'
          >
            Already have an account?{' '}
            <Link
              component={RouterLink}
              sx={loginLinkSx}
              to='../login'
            >
              Login
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default UnregisteredBanner;
